import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useDisclosure } from '@chakra-ui/react';

import { AccountClosureReason } from '__generated__/GQL';
import useCurrentPath from 'common/hooks/useCurrentPath';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import { logEvent } from 'features/Analytics/analytics';

import Title from '../../../components/Title';
import { useShouldSeeCutCardsScreen } from '../../../hooks/useShouldSeeCutCardsScreen';
import { ReasonInitialStep } from '../../constants';
import { getFormDefaultValues } from '../../helpers';
import PricingIssueModal from '../FormStepSatisfaction/components/PricingIssueModal';
import locales from './locales';

const FormStepInitial = () => {
  const { path } = useCurrentPath();
  const { reset } = useFormContext();
  const { shouldSeeCutCardsScreen } = useShouldSeeCutCardsScreen();
  const { onOpen, ...modalProps } = useDisclosure();
  const history = useHistory();

  const stopActivityNextLink = shouldSeeCutCardsScreen
    ? '/company/account-closure/cut-cards'
    : '/company/account-closure/confirm';

  return (
    <>
      <Title>{locales.title}</Title>

      <Text fontSize="font-15" mb="space-40" size="sm">
        {locales.subtitle}
      </Text>

      <SunshineCard.Group>
        <SunshineCard
          as={Link}
          onClick={() => {
            const defaultValues = getFormDefaultValues();

            reset({
              ...defaultValues,
              reasons: new Set([AccountClosureReason.StopActivity]),
            });
          }}
          title={locales[ReasonInitialStep.StopActivity]}
          to={stopActivityNextLink}
        >
          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>

        <SunshineCard
          as={Link}
          title={locales[ReasonInitialStep.Satisfied]}
          to={`${path}/satisfaction/satisfied`}
        >
          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>

        <SunshineCard
          as={Link}
          title={locales[ReasonInitialStep.Unsatisfied]}
          to={`${path}/satisfaction/unsatisfied`}
        >
          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>

        <SunshineCard
          as={Link}
          onClick={() => {
            onOpen();
            logEvent({
              name: `Account Closure reason ${ReasonInitialStep.Other} selected`,
            });
          }}
          title={locales[ReasonInitialStep.Other]}
        >
          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>
      </SunshineCard.Group>
      <PricingIssueModal
        onCloseLink={() => history.push(`${path}/satisfaction/other`)}
        {...modalProps}
      />
    </>
  );
};

export default FormStepInitial;
